var parent = require('../../actual/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/define-property.js
// module id = 504
// module chunks = 0 1